<template>
  <popup-layout :title="titleNm" :is-show="isShow" width="90vw" max-width="1200px">
    <template v-slot:content>
      <v-data-table
        height="45vh"
        :headers="getHeader(headers)"
        :items="detailData"
        fixed-header
        :items-per-page="-1"
        mobile-breakpoint="md"
      >
        <template v-slot:item.executionDate="{ value }">
          <div>{{ setDashDate(value) }}</div>
        </template>
        <template v-slot:item.maturityDate="{ value }">
          <div>{{ setDashDate(value) }}</div>
        </template>
        <template v-slot:item.loanAmount="{ value }">
          <div>{{ inputComma(value) }}</div>
        </template>
        <template v-slot:item.prevLoanAmount="{ value }">
          <div>{{ inputComma(value) }}</div>
        </template>
        <template v-slot:item.repayAmount="{ value }">
          <div>{{ inputComma(value) }}</div>
        </template>
        <template v-slot:item.feeBaseAmount="{ value }">
          <div>{{ inputComma(value) }}</div>
        </template>
        <template v-slot:item.feeTotal="{ value }">
          <div>{{ inputComma(value) }}</div>
        </template>
      </v-data-table>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button" outlined @click="closePopup">닫기</v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import {axiosInstance} from "@/util/AxiosModule";
import TableMixin from "@/mixin/TableMixin";
import {LOAN_PERFORMANCE_MINE_DETAIL_TABLE} from "@/util/TableHeaders";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "MemberPerformanceDetail",
  components: {PopupLayout},
  props: ["isShow", "paramsData", "rowData"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      titleNm: "",
      headers: LOAN_PERFORMANCE_MINE_DETAIL_TABLE,
      detailData: []
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        this.getMemberDetailData();
        this.titleNm = this.rowData.agentNm + "님의 실적 상세";
      }
    }
  },
  methods: {
    async getMemberDetailData() {
      const params = {
        stDt: this.paramsData.stDt,
        edDt: this.paramsData.edDt,
        nm: this.rowData.agentNm,
        team: this.rowData.teamNm
      };
      try {
        const { data } = await axiosInstance.get("/private/performance/performance", { params });
        if (data.length < 1) {
          this.detailData = [];
        } else {
          this.detailData = data.performance;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    closePopup() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>